import { AxiosError } from 'axios';

import { ZOR_GENERAL_SETTING_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { ZorGeneralSetting } from '@/types/zor.general-setting.type';

export const getZorGeneralSetting = async (): Promise<
  ApiResponse<ZorGeneralSetting>
> => {
  const orgId = window.localStorage.getItem('active-org-id');
  if (!orgId) return Promise.reject(new Error('No active org ID'));

  try {
    const response = await apiManager.get(
      `${ZOR_GENERAL_SETTING_API_URL}/${orgId}`,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
